<form [formGroup]="loginForm" (ngSubmit)="login()" [class.clinic]="appName === 'clinic'">
  @if (error()) {
    <div class="error-container" [innerHtml]="error()"></div>
  }
  <div class="form-group">
    <label class="sr-only">Email</label>
    <input
      #email
      placeholder="Email"
      class="form-control"
      type="email"
      formControlName="username"
      autocomplete="email"
      (focus)="isAutofilled.set(false)"
      />
    </div>
    <div class="form-group">
      <label class="sr-only">Password</label>
      <input
        #password
        placeholder="••••••••"
        class="form-control"
        type="password"
        formControlName="password"
        autocomplete="password"
        (focus)="isAutofilled.set(false)"
        />
      </div>

      <ng-content select=".additional-login-text" />

      <div class="form-group bottom-form-cta-container">
        <button
          id="login-button"
          class="btn btn-default btn-large"
          [class.btn-loading]="_isLoading()"
          type="submit"
          [disabled]="(loginForm.invalid && !isAutofilled()) || _isLoading() || disabled()"
          >
          Log In
        </button>

        <ng-content select=".login-account-cta" />

      </div>
    </form>